module.exports = __webpack_public_path__ + "assets/img/sabc_social_instagram.webp?2a163386b4d8f6535974323af099d4d2";